var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8516 8.44434C16.4725 8.93595 16.9766 9.57342 17.3237 10.3063C17.6708 11.0391 17.8516 11.8472 17.8516 12.6666C17.8516 13.4859 17.6708 14.294 17.3237 15.0269C16.9766 15.7597 16.4725 16.3972 15.8516 16.8888",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5513 5.27783C19.5952 6.16835 20.4373 7.29408 21.0157 8.57256C21.5942 9.85104 21.8944 11.2499 21.8944 12.6667C21.8944 14.0835 21.5942 15.4824 21.0157 16.7609C20.4373 18.0394 19.5952 19.1651 18.5513 20.0556",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85156 15.8332H4.85156C4.58635 15.8332 4.33199 15.722 4.14446 15.5241C3.95692 15.3261 3.85156 15.0576 3.85156 14.7777V10.5555C3.85156 10.2755 3.95692 10.007 4.14446 9.80907C4.33199 9.61111 4.58635 9.4999 4.85156 9.4999H6.85156L10.3516 4.7499C10.439 4.5707 10.5842 4.43041 10.7611 4.35438C10.9379 4.27835 11.1347 4.27159 11.3158 4.33533C11.497 4.39906 11.6505 4.52909 11.7488 4.70192C11.847 4.87474 11.8835 5.07896 11.8516 5.27768V20.0555C11.8835 20.2542 11.847 20.4584 11.7488 20.6312C11.6505 20.804 11.497 20.9341 11.3158 20.9978C11.1347 21.0616 10.9379 21.0548 10.7611 20.9788C10.5842 20.9027 10.439 20.7624 10.3516 20.5832L6.85156 15.8332Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundIcon);
export default __webpack_public_path__ + "static/media/sound-icon.2f7d0685a0d0ad3ea94e04a3d1813618.svg";
export { ForwardRef as ReactComponent };